function money(amount) {
    return `<amount>${amount}</amount>`
}
function globalStatus(status) {
    let r
    switch (status) {
        case 'Aktif':
            r = '<span class="badge rounded-pill bg-success">Aktif</span>'
            break;
        case 1:
            r = '<span class="badge rounded-pill bg-success">Aktif</span>'
            break;
        case 'Pasif':
            r = '<span class="badge rounded-pill bg-danger">Pasif</span>'
            break;
        case 2:
            r = '<span class="badge rounded-pill bg-danger">Pasif</span>'
            break;
        default:
        r = status
            break;
    }
    return r
}
function ability(roleName) {
    const userdata = JSON.parse(localStorage.getItem('userdata'))

    if(roleName){
        const noAuth = userdata.abilities ?? [];
        if(noAuth == '*') return true
        return noAuth.includes(roleName)
    }
}
function getRolename() {
    const userdata = JSON.parse(localStorage.getItem('userdata'))
    return userdata.role_name;
}
function onlyUserCheck(rolename) {
    const userdata = JSON.parse(localStorage.getItem('userdata'))
    return userdata.role_name == rolename
}
function abilityCheck(ability_name) {
	if (!ability_name) return false
    const userdata = JSON.parse(localStorage.getItem('userdata'))
    return userdata.abilities.includes(ability_name.replace('/',''))
}
export {
    globalStatus,
    ability,
    onlyUserCheck,
    money,
    getRolename,
    abilityCheck
}
    
